// Tipos compartidos del Knowledge Universe viewer

export const API_BASE =
  import.meta.env.VITE_API_BASE ||
  'https://knowledge-universe-api.rcastro1089.workers.dev'

// Los note_type vienen en ESPAÑOL desde la API. La columna note_type de la DB
// mantiene la forma capitalizada (CHECK constraint), pero el frontmatter y
// metadata.type usan minúscula. El viewer acepta ambas formas + 'insight'.
export type NodeType =
  | 'Fuente'
  | 'Concepto'
  | 'Meta'
  | 'Proyecto'
  | 'Activo'
  | 'Persona'
  | 'Contexto'
  | 'fuente'
  | 'concepto'
  | 'meta'
  | 'proyecto'
  | 'activo'
  | 'persona'
  | 'contexto'
  | 'insight'

export interface NoteNode {
  id: string
  title: string
  note_type: NodeType | string
  connectivity_count: number
  created_at?: string
}

export interface Edge {
  source_note_id: string
  target_note_id: string
  weight: number
}

export interface NoteDetail {
  id: string
  title: string
  content: string
  note_type: NodeType | string
  tags: string[]
  connectivity_count: number
  created_at?: string
  updated_at?: string
}

export interface Connection {
  id: string
  weight: number
  relationship_type: string
  source_note_id: string
  target_note_id: string
}

export interface SearchResult {
  id: string
  title: string
  note_type: NodeType | string
  tags: string[]
  connectivity_count: number
}

// Forma canónica capitalizada por tipo. Acepta minúscula, capitalizada e 'insight'.
const CANONICAL_TYPE: Record<string, string> = {
  fuente: 'Fuente',
  concepto: 'Concepto',
  meta: 'Meta',
  proyecto: 'Proyecto',
  activo: 'Activo',
  persona: 'Persona',
  contexto: 'Contexto',
  insight: 'Concepto', // las notas de inbox (insight) se agrupan como Concepto
}

// Normaliza cualquier variante de tipo a la forma canónica capitalizada.
export function normalizeType(type: string): string {
  if (!type) return 'Contexto'
  return CANONICAL_TYPE[type.toLowerCase()] || type
}

// Colores por tipo de nodo (en español). El lookup normaliza el caso primero.
export const TYPE_COLORS: Record<string, string> = {
  Fuente: '#ef4444', // rojo
  Concepto: '#3b82f6', // azul
  Meta: '#f59e0b', // amarillo dorado
  Proyecto: '#22c55e', // verde
  Activo: '#f97316', // naranja
  Persona: '#a855f7', // morado
  Contexto: '#e2e8f0', // blanco
}

export const TYPE_ORDER: NodeType[] = [
  'Fuente',
  'Concepto',
  'Meta',
  'Proyecto',
  'Activo',
  'Persona',
  'Contexto',
]

export function colorForType(type: string): string {
  return TYPE_COLORS[normalizeType(type)] || '#e2e8f0'
}

// Tamaño por connectivity_count
export function sizeForNode(connectivity: number): number {
  // 1/4 del tamaño original: (0.5 + min(c*0.2, 2.0)) / 4
  return 0.125 + Math.min(connectivity * 0.05, 0.5)
}

export type Vec3 = [number, number, number]
